import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MapTractorsComponent} from './map-tractors.component';
import {MapSidebarTabsModule} from '../map-sidebar-tabs/map-sidebar-tabs.module';
import {
  DxButtonModule,
  DxCircularGaugeModule,
  DxContextMenuModule, DxDataGridModule,
  DxListModule, DxPopoverModule, DxTooltipModule,
  DxScrollViewModule,
  DxTabsModule, DxTextBoxModule, DxToolbarModule
} from 'devextreme-angular';
import { MapTractorPopupComponent } from './map-tractor-popup/map-tractor-popup.component';
import {BadgeModule} from '../../../../shared/src/lib/components/badge/badge.module';
import {TabModule} from '../tab/tab.module';
import {FieldSvgModule} from 'shared';
import {MapModule} from '../map/map.module';
import {FuelRealtimeConsumptionPopupModule} from '../fuel/fuel-realtime-consumption-popup/fuel-realtime-consumption-popup.module';
import {VehiclesTrackerStateIconsSelectorModule} from '../vehicles/vehicles-tracker-state-icons-selector/vehicles-tracker-state-icons-selector.module';
import {VehiclesIconSelectorModule} from '../vehicles/vehicles-icon-selector/vehicles-icon-selector.module';
import {MapSidebarGroupHeaderModule} from '../map/map-sidebar-group-header/map-sidebar-group-header.module';


@NgModule({
  declarations: [MapTractorsComponent, MapTractorPopupComponent],
    imports: [
        CommonModule,
        MapSidebarTabsModule,
        DxListModule,
        DxCircularGaugeModule,
        DxTabsModule,
        DxScrollViewModule,
        DxButtonModule,
        DxContextMenuModule,
        BadgeModule,
        TabModule,
        DxPopoverModule,
        DxTooltipModule,
        FieldSvgModule,
        MapModule,
        FuelRealtimeConsumptionPopupModule,
        VehiclesTrackerStateIconsSelectorModule,
        DxDataGridModule,
        DxTextBoxModule,
        DxToolbarModule,
        VehiclesIconSelectorModule,
        MapSidebarGroupHeaderModule,
    ],
  exports: [MapTractorsComponent, MapTractorPopupComponent]
})
export class MapTractorsModule {
}
